export default "__VITE_ASSET__DV1aJ3yU__"